module.exports = "<div class=circle> <i class=\"{{ icon }}\"></i> <div class=\"arc arc-1\"></div> <div class=\"arc arc-2\"></div> </div> ";